import { Chat, Project } from './types'

export const mockProjects: Project[] = [
  { id: 'p1', name: 'Q3 Marketing Launch' },
  { id: 'p2', name: 'Competitor Analysis' },
  { id: 'p3', name: 'Email Funnel Redesign' },
  { id: 'p4', name: 'Product Launch Playbook' },
  { id: 'p5', name: 'Social Media Strategy' },
]

export const mockChats: Chat[] = [
  { id: 'c1', title: 'Test Conversation' },
  { id: 'c2', title: 'AI Assistant Capabilities Overview' },
  { id: 'c3', title: 'Research my top competitors' },
  { id: 'c4', title: 'Draft email to investors' },
  { id: 'c5', title: "Summarize this week's revenue" },
  { id: 'c6', title: 'Brainstorm blog post ideas' },
  { id: 'c7', title: 'Review Q2 performance metrics' },
  { id: 'c8', title: 'Create onboarding checklist' },

  // Chats in projects
  { id: 'c9', title: 'Campaign messaging draft', projectId: 'p1' },
  { id: 'c10', title: 'Target audience personas', projectId: 'p1' },
  { id: 'c11', title: 'Feature comparison matrix', projectId: 'p2' },
  { id: 'c12', title: 'Pricing strategy review', projectId: 'p2' },
  { id: 'c13', title: 'Welcome sequence copy', projectId: 'p3' },
  { id: 'c14', title: 'A/B test subject lines', projectId: 'p3' },
  { id: 'c15', title: 'Launch timeline draft', projectId: 'p4' },
  { id: 'c16', title: 'Content calendar Q3', projectId: 'p5' },
  { id: 'c17', title: 'Instagram reel ideas', projectId: 'p5' },
]
